type Props = {
  size?: string;
  margin?: string;
  children: React.ReactNode;
};

const LayoutContainer = ({ size = 'md', margin, children }: Props) => {
  return (
    <div className={`l-container l-container--${size} ${margin ? margin : ''}`}>{children}</div>
  );
};

export default LayoutContainer;
